export default {
  gridGap: 48,
  gridGapLg: 120,

  textOpacity: 0.25,
  textOpacityMedium: 0.5,

  submenuIndent: 50,

  colors: {
    primary: "#afc91d",
    green: {
      100: "#69923a",
      200: "#8daa0b",
      300: "#afc91d",
      400: "#cddb47",
    },
    blue: {
      100: "#0bb1dd",
      200: "#099fd3",
      300: "#068dc9",
      400: "#047cbf",
      500: "#026db5",
      600: "#015ea9",
      700: "#025d9b",
      800: "#035b8c",
      900: "#04577c",
      1000: "#05526d",
      1100: "#054b5e",
    },
    gray: "#C2C2C2",
    grayLessDark: "#616161",
    grayDark: "#424242",
    grayLight: "#EDEDED",
    status: {
      red: "#e52323",
      yellow: "#ffe000",
      green: "#58a618",
    },
  },

  mq: {
    tablet: {
      query: "(min-width: 768px)",
    },
    desktop: {
      query: "(min-width: 1200px)",
    },
    desktopLarge: {
      query: "(min-width: 1500px)",
    },
  },
}
